(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/helpers.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/helpers.js');
'use strict';

const makeSetting = (key, value) => ({
  key,
  value
});

const findDiffs = (newData, currentData) => {
  const diffs = [];
  for (const id in currentData) {
    if (currentData[id] !== newData[id]) {
      diffs.push(makeSetting(id, newData[id]));
    }
  }
  return diffs;
};

const clearAllUrlParam = () => {
  svs.utils.url.refreshQueryString();
  window.history.replaceState({}, '', "".concat(window.location.pathname));
  svs.utils.url.refreshQueryString();
};

const getCAndI = () => {
  const isPlayerLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  let c = '';
  let i = '';
  if (!isPlayerLoggedIn) {
    var _svs$utils$url$queryS, _svs$utils$url$queryS2;
    c = (_svs$utils$url$queryS = svs.utils.url.queryString) !== null && _svs$utils$url$queryS !== void 0 && _svs$utils$url$queryS.c ? svs.utils.url.queryString.c : '';
    i = (_svs$utils$url$queryS2 = svs.utils.url.queryString) !== null && _svs$utils$url$queryS2 !== void 0 && _svs$utils$url$queryS2.i ? svs.utils.url.queryString.i : '';
    svs.myProfile.logger.debug("**** CommunicationSettings not isPlayerLoggedIn i: ".concat(i, ", c: ").concat(c));
  }
  return {
    c,
    i
  };
};
svs.myProfile.react.shared.helpers = {
  makeSetting,
  findDiffs,
  clearAllUrlParam,
  getCAndI
};

 })(window);